// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_yLH","cls2":"ReferenceEvaluationPage-cls2_l4s ReferenceEvaluationPage-cls1_yLH"};